import { render } from 'preact';
import { App } from './ui/App';
import { InstallPrompt } from './ui/InstallPrompt';
import { UpdatePrompt } from './ui/UpdatePrompt';
import './ui/styles.css';

const root = document.getElementById('app');
if (!root) {
  throw new Error('Missing #app mount point in index.html');
}

/**
 * The service worker is registered here rather than inside `App` so that the
 * component tree stays free of the `virtual:pwa-register` module, which only
 * exists during a Vite build.
 */
function Root() {
  return (
    <>
      {/* One fixed slot above the tab bar; multiple banners stack instead of overlapping. */}
      <div class="banner-stack">
        <UpdatePrompt />
        <InstallPrompt />
      </div>
      <App />
    </>
  );
}

render(<Root />, root);
